











import {ChartDataTemplate, FCConfTpl, WConfTpl, WidgetDefinition, WParamTpl} from '@/components/widgets/WidgetFather'
import {defineComponent, reactive} from "@vue/composition-api"
import FusionChartWidget from "@/components/widgets/FusionChartWidget.vue"
import {getLocationCaption} from "@/data/sources/appraisal"
import {executeQuery} from "@/data/repos/query";
import appConfig from "@/config";
import {formatNumberWithGrouping} from "@/data/sources/numbers";


export function config(): WidgetDefinition {
    return {
      ...WConfTpl.Doughnut2D(),
      widget: "AgeProfile",
      title: "Age profile by built date",
      _description: "Age profile by built date",
      params: {
        locationId: {...WParamTpl.locationId(), _order: 1},
      },
      fusionChartParams: {
      },
    }
  }

  function getChartConfig() {
    return reactive(FCConfTpl())
  }

  function getChartDataConfig() {
    return reactive({
        ...ChartDataTemplate(),
        // centerLabel: "$label, $value",
        caption: 'Area (sq. m)',
      bgColor: "#ffffff",
        showLegend: '0',
        // labelDisplay: '$label , $value',
        centerAngle: "180",
      inThousandSeparator: ",",
        // plotToolText: "$label, $value, $percentValue",
        showLabels: '1',
        showValues: '1',
        showPercentageValues: "1",
      },
    )
  }

  export default defineComponent({
    props: {
      config: Object,
    },
    components: {
      FusionChartWidget,
    },
    setup(props, context) {
      context.emit("config-update", config())

      let savedChartDataConfig
      async function configChangeCallback(config: any, chartConfig: any, chartDataConfig: any) {
        if (config) {
          savedChartDataConfig = chartDataConfig
          chartDataConfig.subCaption = "Location: " + await getLocationCaption(config.params.locationId)
        }
      }

      async function dataFetcher(params: any): Promise<{ data: any[] }> {
        const data = await executeQuery(
            "idr",
            "eric.ageProfile", {
              locationId: parseInt(params.locationId.value),
              cpId: 59 /* todo */
            });
        // [{"GiaTotal":1775.2500,"range":"Pre 1948","buildingCount":1}]
        // console.info("AgeProfile:", data)
        const totalGia = data.reduce((sum, item) => sum + item.GiaTotal, 0)
        if (savedChartDataConfig)
          savedChartDataConfig.defaultCenterLabel = "Total GIA: " + formatNumberWithGrouping(totalGia) + " Sq.m"
        const palette: Map<string, string> = new Map<string, string>([
            ["2015 to 2024","#708834"],
            ["2005 to 2014", "#B3BF4C"],
            ["1995 to 2004", "#FBE377"],
            ["1985 to 1994", "#FBA038"],
            ["1975 to 1984", "#D0671C"],
            ["1965 to 1974", "#964059"],
            ["1955 to 1964", "#D86680"],
            ["1948 to 1954", "#EF7BDC"],
            ["Pre 1948", "#B080A0"],
            ["Unassigned", "#FF0000"]
        ])
        // {"GiaTotal":1775.2500,"range":"Pre 1948","buildingCount":1}
        return {
          data: data.map(item => {
            return {
              label: item.range,
              value: item.GiaTotal,
              toolText: item.range + " - " + formatNumberWithGrouping(item.GiaTotal) + " Sq.m, " + formatNumberWithGrouping(100 * item.GiaTotal / totalGia) + "%",
              color: palette.get(item.range) || "#000000",
            }
          }),
        }
      }

      function dataplotClickCallback(label: string, val: any) {
        const iprUrl = appConfig.IPR_BASE_URL
        const locationId = props.config.params.locationId.value
        window.open(iprUrl + `/pages/eric_site.asp?id=${locationId}&return=site_details.aspx?id=${locationId}`)
        console.log("chartClickCallback", label, val)
      }

      return {dataFetcher, getChartDataConfig, dataplotClickCallback, configChangeCallback}
    },
  })
